'use strict';

var Layout = (function () {
    var initLayout = function () {

    };
    return {
        init: function () {
            initLayout();
        },
    };
})();

document.addEventListener('DOMContentLoaded', function () {
    Layout.init();
});
